import React from 'react';
import { SectionWrapper } from './Shared';
import { BatteryWarning, Brain, Activity, ShieldAlert } from 'lucide-react';
export const Pain = () => {
  const pains = [{
    icon: <Brain className="w-8 h-8 text-prime-gold" data-id="element-99" />,
    text: "Llegas a las 3 PM y el 'brain fog' (niebla mental) te impide enfocarte en esa reunión crucial."
  }, {
    icon: <BatteryWarning className="w-8 h-8 text-prime-gold" data-id="element-100" />,
    text: 'Llegas a casa y no tienes energía para jugar con tus hijos, y mucho menos para conectar con tu esposa.'
  }, {
    icon: <Activity className="w-8 h-8 text-prime-gold" data-id="element-101" />,
    text: "Ves cómo tu abdomen se expande a pesar de que 'comes sano' y sientes tus articulaciones rígidas al despertar."
  }, {
    icon: <ShieldAlert className="w-8 h-8 text-prime-gold" data-id="element-102" />,
    text: 'Y lo peor de todo: ese sutil miedo de que tus mejores años hayan quedado atrás.'
  }];
  return <SectionWrapper data-id="element-103">
      <div className="mb-16 text-center" data-id="element-104">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-105">
          El Motor Se Está Apagando
        </h2>
        <p className="text-xl text-prime-textMuted max-w-2xl mx-auto" data-id="element-106">
          Trabajas duro. Eres el proveedor. Eres el líder. Pero por dentro...
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-107">
        {pains.map((pain, idx) => <div key={idx} className="bg-prime-card border border-white/5 p-8 rounded-lg hover:border-prime-gold/30 transition-colors" data-id="element-108">
            <div className="mb-4 bg-prime-black inline-block p-3 rounded-full border border-white/10" data-id="element-109">
              {pain.icon}
            </div>
            <p className="text-lg text-prime-text leading-relaxed" data-id="element-110">
              {pain.text}
            </p>
          </div>)}
      </div>

      <div className="bg-prime-red/10 border border-prime-red/20 p-8 rounded-lg text-center" data-id="element-111">
        <p className="text-xl md:text-2xl text-white font-serif italic mb-4" data-id="element-112">
          Te han vendido la idea de que "es solo la edad"...
        </p>
        <p className="text-lg text-prime-textMuted" data-id="element-113">
          Pero la ciencia moderna nos dice que es un fallo en tu arquitectura
          biológica. Estás operando con un{' '}
          <span className="text-prime-gold font-semibold" data-id="element-114">
            software de 45 años en un hardware que no ha sido actualizado
          </span>
          , y tu cuerpo está gritando por ayuda.
        </p>
      </div>
    </SectionWrapper>;
};